export enum EnumMasOpciones {
  Ajustar = 'MENSAJES.GRALS.AJUSTAR',
  ExportarExcel = 'MENSAJES.GRALS.EXPORTAR_EXCEL',
  ExportarPDF = 'MENSAJES.GRALS.EXPORTAR_PDF',
  Expandir = 'MENSAJES.GRALS.EXPANDIR',
  Colapsar = 'MENSAJES.GRALS.COLAPSAR',
  LimpiarFiltroColumnas = 'MENSAJES.GRALS.LIMPIAR_FILTRO_COL',
  Actualizar = 'MENSAJES.GRALS.ACTUALIZAR',
  Presupuesto = 'MENSAJES.GRALS.PPTO',
  Maestro = 'MENSAJES.GRALS.MAESTRO',
  ActualizacionConsultas = 'MENSAJES.GRALS.ACTUALIZARCONSULTAS',
  Configuraciones = 'MENSAJES.GRALS.CONFIGURACIONES',
  RestablecerTabs = 'MENSAJES.GRALS.RESTABTABS',
  RestablecerConfigGrids = 'MENSAJES.GRALS.RESTABCONFIGGRIDS',
  CerrarMatrices = 'MENSAJES.GRALS.CERRARMATRICES',
  CerrarMatricesMaestro = 'MENSAJES.GRALS.CERRARMATRICESMAESTRO',
  FormatosExcel = 'MENSAJES.GRALS.FORMATOSEXCEL',
  ComandosComponentes = 'MENSAJES.GRALS.COMANDOSCOMPONENTES',
  Respaldar = 'BOTONES.RESPALDAR',
  Compartir = 'BOTONES.COMPARTIR',
  UnirFileManager = 'MENSAJES.GRALS.UNIR_FILE_MANAGER'
}

export enum EnumMIMETypes {
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS = 'application/vnd.ms-excel',
  PDF = 'application/pdf',
  ZIP = 'application/zip',
  OTRO = 'application/octet-stream'
}

export enum EnumRepListadoInsMasOpciones {
  IMP_INS_COSTO_CERO = 'MENSAJES.GRALS.REP_IMP_INS_COSTO_CERO',
  IMP_INS_PARTICIPAN = 'MENSAJES.GRALS.REP_IMP_INS_PARTICIPAN',
  IMP_POR_MA_MO = 'MENSAJES.GRALS.REP_IMP_POR_MA_MO',
  IMP_DESC_COMPLETA = 'MENSAJES.GRALS.REP_IMP_DESC_COMPLETA',
  IMP_MAQUINARIA = 'MENSAJES.GRALS.REP_IMP_MAQUINARIA',
  IMP_RELACION_BASICOS = 'MENSAJES.GRALS.REP_IMP_RELACION_BASICOS'
}

export enum EnumRepListadoMatMasOpciones {
  IMP_DESC_COMPLETA_MATRIZ = 'MENSAJES.GRALS.REP_IMP_DESC_COMPLETA_MATRIZ',
  IMP_DESC_COMPLETA_INSUMOS = 'MENSAJES.GRALS.REP_IMP_DESC_COMPLETA_INSUMOS',
  IMP_INS_COSTO_CERO = 'MENSAJES.GRALS.REP_IMP_INS_COSTO_CERO',
  IMP_PRECIO_LETRA = 'MENSAJES.GRALS.REP_IMP_PRECIO_LETRA',
  IMP_CODIGO_AUXILIAR = 'MENSAJES.GRALS.REP_IMP_CODIGO_AUXILIAR'
}

export enum EnumRepListadoPptoMasOpciones {
  IMP_IVA = 'MENSAJES.GRALS.REP_PPTO_IMP_IVA',
  IMP_DESC_LARGA_PARTIDA = 'MENSAJES.GRALS.REP_PPTO_DESC_LARGA_PARTIDA',
  IMP_DESC_LARGA_CONCEPTO = 'MENSAJES.GRALS.REP_PPTO_DESC_LARGA_CONCEPTO',
  IMP_CODIGO_AUXILIAR = 'MENSAJES.GRALS.REP_IMP_CODIGO_AUXILIAR'
}

export enum EnumRepProgObraDetalleOpciones {
  IMP_BARRA_DURACION = 'MENSAJES.GRALS.REP_PROG_IMP_BARRA_DURACION',
  IMP_MONTOS = 'MENSAJES.GRALS.REP_PROG_IMP_MONTOS',
  IMP_PORCENTAJES = 'MENSAJES.GRALS.REP_PROG_IMP_PORCENTAJES',
  IMP_CANTIDADES = 'MENSAJES.GRALS.REP_PROG_IMP_CANTIDADES'
}

export enum EnumRepProgObraMasOpciones {
  IMP_CODIGO_PARTIDA = 'MENSAJES.GRALS.REP_PROG_IMP_CODIGO_PARTIDA',
  IMP_DESC_LARGA_PARTIDA = 'MENSAJES.GRALS.REP_PPTO_DESC_LARGA_PARTIDA',
  IMP_DESC_LARGA_CONCEPTO = 'MENSAJES.GRALS.REP_PPTO_DESC_LARGA_CONCEPTO'
}

export enum EnumRepProgObraEncabezadoPeriodos {
  POR_PERIODO = 'MENSAJES.GRALS.REP_PROG_ENC_POR_PERIODO',
  POR_FECHA = 'MENSAJES.GRALS.REP_PROG_ENC_POR_FECHA'
}

export enum EnumRepProgSumConceptoConceptoOpciones {
  IMP_CODIGO_AUXILIAR = 'MENSAJES.GRALS.REP_PROG_SUM_IMP_COD_AUX_CONCEPTO',
  IMP_DESC_LARGA_CONCEPTO = 'MENSAJES.GRALS.REP_PROG_SUM_IMP_DESC_LARGA_CONCEPTO'
}

export enum EnumRepProgSumConceptoInsumosOpciones {
  IMP_DESC_LARGA = 'MENSAJES.GRALS.REP_PROG_SUM_IMP_DESC_LARGA',
  NO_IMP_IMPORTE_CERO = 'MENSAJES.GRALS.REP_PROG_SUM_NO_IMP_IMPORTE_CERO'
}

export enum EnumRepProgSumConceptoPartidaOpciones {
  IMP_DESC_LARGA_PARTIDA = 'MENSAJES.GRALS.REP_PROG_SUM_IMP_DESC_LARGA_PARTIDA'
}

export enum EnumOpcionesNotificacion {
  CLEAR_ALL_NOTIF = 'MENSAJES.GRALS.LIMPIAR_TODAS_NOTIFICACIONES',
  EXPORT_ALL_NOTIF = 'MENSAJES.GRALS.EXPORTAR_EXCEL'
}

export enum EnumNivelNotificacion {
  SISTEMA = 'MENSAJES.GRALS.NIVEL_NOTIF_SISTEMA',
  ORGANIZACION = 'MENSAJES.GRALS.NIVEL_NOTIF_ORGANIZACION',
  PRESUPUESTO = 'MENSAJES.GRALS.NIVEL_NOTIF_PPTO',
  USUARIO = 'MENSAJES.GRALS.NIVEL_NOTIF_USUARIO'
}

export enum EnumUltimoUserModificoDesdeDonde {
  MATRIZ = 1,
  CATALOGO = 2,
  COSTO_HORARIO = 3,
  CONCEPTOS = 4,
  IMPORTAR_MATRIZ = 5
}

export enum EnumPosicionBtn {
  IZQUIERDA = 0,
  DERECHO = 1
}
